import request from "@/util/http";
// * 添加属性
export function populate(query) {
	return request({
		url: '/marketing/shop/coupon_code/populate',
		params: query,
	})
}

//  兑换
// 查询优惠券列表
export function exchange_list(query) {
	return request({
		url: '/marketing/shop/coupon_code/exchange_list',
		method: 'get',
		params: query,
	})
}

//  兑换
export function exchange(query) {
	return request({
		url: '/marketing/shop/coupon_code/exchange',
		method: 'post',
		params: query,
	})
}


//  兑换
// 查询优惠券列表
export function getCoupon(query) {
	return request({
		url: '/marketing/shop/coupon_code/get_coupon',
		method: 'get',
		params: query,
	})
}



// 兑换
export function exchangeBody(data) {
	return request({
		url: '/marketing/shop/coupon_code/exchange',
		method: 'post',
		data: data,
	})
}

// 列表		
export function listCoupon(query) {
	return request({
		url: '/marketing/shop/coupon_code/list',
		method: 'get',
		params: query,
	})
}

// 列表
export function listCouponJson(query) {
	return request({
		url: '/marketing/shop/coupon_code/listJson',
		method: 'get',
		params: query,
	})
}

// module.exports = {
// 	populate,
// 	exchange,
// 	exchange_list,
// 	getCoupon,
// 	exchangeBody,
// 	listCoupon,
// 	listCouponJson
// }
